import { Button, Select, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import dayjs from "dayjs";
import {
  STATUS_OPTIONS,
  GATEWAY_OPTIONS,
  MANUAL_PAYMENT_OPTIONS,
  RETRY_PAYMENT_OPTIONS,
  COVER_TYPE_OPTIONS,
  PURCHASE_METHOD_OPTIONS,
  PROMOCODE_OPTIONS,
  currencyOptions,
} from "../../utils/paymentConstants";
import classes from "./PaymentToolbar.module.css";

const H = 44;
const hideDateClearStyles = { section: { display: "none" } };

const FilterSelect = ({ data, value, onChange }) => (
  <Select
    data={data}
    value={value}
    onChange={(val) => onChange(val || "")}
    className={classes.select}
    h={H}
    allowDeselect={false}
  />
);

const DateRange = ({ label, range, onChange }) => (
  <div className={classes.dateCell}>
    <Text size="sm" fw={600} className={classes.dateLabel}>{label}:</Text>
    <DateInput
      value={range[0]}
      onChange={(val) => {
        const end =
          range[1] && val && dayjs(range[1]).isBefore(dayjs(val), "day") ? null : range[1];
        onChange([val, end]);
      }}
      placeholder="mm/dd/yyyy"
      valueFormat="MM/DD/YYYY"
      h={H}
      clearable={false}
      className={classes.dateInput}
      styles={hideDateClearStyles}
    />
    <Text c="dimmed" size="sm">→</Text>
    <DateInput
      value={range[1]}
      onChange={(val) => onChange([range[0], val])}
      placeholder="mm/dd/yyyy"
      valueFormat="MM/DD/YYYY"
      minDate={range[0] ? dayjs(range[0]).startOf("day").toDate() : undefined}
      h={H}
      clearable={false}
      className={classes.dateInput}
      styles={hideDateClearStyles}
    />
  </div>
);

const PaymentToolbar = ({
  filters,
  onChange,
  currencies,
  isFull = false,
  showClear = false,
  onClear,
}) => {
  const fullSelects = [
    { key: "gateway", data: GATEWAY_OPTIONS },
    { key: "currency", data: currencyOptions(currencies) },
    { key: "manual", data: MANUAL_PAYMENT_OPTIONS },
    { key: "retry", data: RETRY_PAYMENT_OPTIONS },
    { key: "coverType", data: COVER_TYPE_OPTIONS },
    { key: "purchaseMethod", data: PURCHASE_METHOD_OPTIONS },
    { key: "promocode", data: PROMOCODE_OPTIONS },
  ];

  const toolbarBottomContent = (
    <div className={classes.filterGrid}>
      <FilterSelect
        data={STATUS_OPTIONS}
        value={filters.status}
        onChange={(val) => onChange("status", val)}
      />

      {isFull &&
        fullSelects.map(({ key, data }) => (
          <FilterSelect
            key={key}
            data={data}
            value={filters[key]}
            onChange={(val) => onChange(key, val)}
          />
        ))}

      <DateRange
        label="Date"
        range={filters.updatedRange}
        onChange={(range) => onChange("updatedRange", range)}
      />

      {showClear ? (
        <div className={classes.clearCell}>
          <Button variant="subtle" color="gray" size="compact-sm" onClick={onClear}>
            Clear
          </Button>
        </div>
      ) : null}
    </div>
  );

  return { toolbarBottomContent };
};

export default PaymentToolbar;
